import request from "@/utils/request";
import Qs from "qs";

const api = {
  findPage: "/api/comScheduleJob/findPage",
  save: "/api/comScheduleJob/save",
  del: "/api/comScheduleJob/delete"
};

/**
 * 分页查询
 * @param parameter
 * @returns {*}
 */
export function findPage(parameter) {
  return request({
    url: api.findPage,
    method: "get",
    params: parameter
  });
}

/**
 * 保存/编辑
 * @param {*} parameter
 */
export function save(parameter) {
  return request({
    url: api.save,
    method: "post",
    data: Qs.stringify(parameter)
  });
}

/**
 * 删除
 * @param {*} parameter
 */
export function del(parameter) {
  return request({
    url: api.del,
    method: "post",
    data: Qs.stringify(parameter)
  });
}
